import { ControllerProps, FieldPath, FieldValues } from 'react-hook-form';

import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from '../../form';
import { TFormControlWrapper } from './types';

export const FormControlWrapper = <TSchema extends FieldValues>({
  controlFormProps,
  children,
  ...props
}: TFormControlWrapper<TSchema>) => {
  return (
    <Form {...controlFormProps}>
      <form {...props}>{children}</form>
    </Form>
  );
};

export const FieldControl = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  render,
  isShowMessage = true,
  itemClassName,
  ...props
}: ControllerProps<TFieldValues, TName> & {
  isShowMessage?: boolean;
  itemClassName?: string;
}) => {
  return (
    <FormField
      {...props}
      render={(renderParams) => (
        <FormItem className={itemClassName}>
          <FormControl>{render(renderParams)}</FormControl>
          {isShowMessage && <FormMessage />}
        </FormItem>
      )}
    />
  );
};
